import { render } from "./LoginPageHeader.vue?vue&type=template&id=13cd5fe6&ts=true"
import script from "./LoginPageHeader.vue?vue&type=script&lang=ts"
export * from "./LoginPageHeader.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__